// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vGutterX":"30px","tablet-landscape-up":"(min-width: calc(1024 * 1px))","container":"PageTitle_container__2Ru5a","title":"PageTitle_title__1OOw7"};